import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';

import { Store, select } from '@ngrx/store';
import { RightHeldDto } from '@cradua/data';
import { Observable } from 'rxjs/internal/Observable';
import { routeAnimations, ROUTE_ANIMATIONS_ELEMENTS } from 'libs/core/src/lib/animations';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';

@Component({
  selector: 'cradua-right-held-container',
  templateUrl: './right-held-container.component.html',
  styleUrls: ['./right-held-container.component.scss']
})
export class RightHeldContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  righthelds$: Observable<RightHeldDto[]>;
  loading: boolean;
  isLoading$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoading$ = this.gatwayFacade.isLoadingGateway("RightHeld");
    this.righthelds$ = this.gatwayFacade.loadGateway("RightHeld");
    this.righthelds$.subscribe(data => {
      console.log("data: cont.",data);

    })
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteRightHeld(deletedValue: any) {
    this.gatwayFacade.remove("RightHeld", deletedValue);
    // this.store.dispatch(RightHeldStoreActions.removeRightHeld({ids: deletedValue}));
    this.notificationService.success('Deleted Successfully');
  }


// this method control both the create and update

  onSubmitRightHeld(formValue: any) {
    console.log("form value: ", formValue);
    formValue.RightHelds = formValue.RightHelds.reverse();
    event.preventDefault();
    const pullData = formValue.RightHelds;
    //const newPullData = formValue.RightHeldes;

// declare two empty array to hold update and create data
  let allUpdates = [] ;
  let addAllRightHeld = [];


// loop through the form data to check for update and create

  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllRightHeld.push(pullData[i]);
    }
  }

// check if the addAllRightHeld array is not empty, then dispatch the data to the store
   if(addAllRightHeld.length !== 0) {
    this.gatwayFacade.add('RightHeld', addAllRightHeld);
    // this.store.dispatch(RightHeldStoreActions.addRightHeld({newRightHeld: addAllRightHeld}));

   }

// dispatch update data to the store
this.gatwayFacade.update('RightHeld', allUpdates, ['id']);
    // this.store.dispatch(RightHeldStoreActions.updateRightHeld({updateRightHeld: allUpdates}));
    this.notificationService.success('Saved Successfully');

  }

}



